<style lang="less" scoped>
@import url('../../../style/common/variable.less');
@media screen and (min-width: @max-screen)
{
  .searchBarKYXM{
    ul {width: 1200px;}
    .input{width: 166px !important;font-size: 14px !important;}
    .button{width: 40px !important;height: 40px !important;font-size: 24px;}
  }
}
@media screen and (max-width: @max-screen)
{
  .searchBarKYXM{
    ul{width: 96%;padding: 0;margin: auto;}
    .input{width: 120px !important;font-size: 12px !important;}
    .button{width: 32px !important;height: 32px !important;font-size: 20px;}
    /deep/.el-input__inner{height: 32px!important;}
  }
}
.searchBarKYXM {position: relative;
ul {display: flex;list-style: none;}
li {float: left;margin-right: 21px;font-size: 14px;}
.input {font-family: MicrosoftYaHei;}
.el-select {width: 166px !important;font-family: MicrosoftYaHei;}
.button {background-color: white;border: solid rgb(219, 216, 216);border-width: 1px;border-radius: 5px;cursor: pointer;}}
.button:active{color:#13569e;}
</style>

<template>
  <div class="searchBarKYXM">
    <ul>
      <li>
        <el-input class="input" v-model="Input" placeholder="请输入关键词"></el-input>
      </li>
       <li>
        <el-select v-model="ZhongLei" placeholder="分类" :clearable="true">
          <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </li>
      <li>
        <button class="button" @click="searchdata([Input, ZhongLei])"><i class="el-icon-search"></i></button>
      </li>
    </ul>
  </div>
</template>

<script>
/**
 * 何宽 2021.7.6
 * 搜索栏：四个select框、一个input框、一个搜索按钮，根据设置的条件搜索数据
 */
export default {
  data()
  {
    return {
      options2: [],
      GuoJia: '',
      Input: '',
      ZhongLei: ''
    }
  },
  created()
  {
    this.gettype()
  },
  methods: {
    gettype()
    {
      let paras = {cmd: 'query', _major: 99, _minor: 20, _exp: 'moduleid = 26', orderby: 'id DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        this.options2 = []
        ret.forEach(item =>
        {
          this.options2.push({value: item.id, label: item.dispc})
        })
      })
    },
    searchdata(arr)
    {
      this.$emit('searchdata', arr)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/SearchBarKYQTJ.vue